import { render, staticRenderFns } from "./TypeRent.vue?vue&type=template&id=b3ffeb94&"
import script from "./TypeRent.vue?vue&type=script&lang=js&"
export * from "./TypeRent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports